export default __webpack_public_path__ + "static/media/out1.31a3cb8a.mp3";